<template>
	<div v-if="!loading" class="data-list-container data-list-list-view data-list-high-rows vs-con-loading__container"
		id="main-div">
		<p class="text-subtitle">
			<strong>Selecciona un periodo preestablecido o define un rango de fechas y presiona el botón
				"Consultar".</strong>
		</p>
		<br />
		<div class="vx-row">
			<div class="vx-col w-full sm:w-2/4 lg:w-1/5 mb-4">
				<vs-select class="w-full mb-5" @input="setPeriodSelected" label="Periodos" v-model.lazy="selectedPeriod"
					name="selectedPeriod" placeholder="Seleccione una opción">
					<vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in periodsFilter"
						class="w-full" />
				</vs-select>
			</div>
			<div v-if="projectsFilter.length > 2" class="vx-col w-full sm:w-2/4 lg:w-1/5">
				<vs-select class="w-full mb-5" @input="setProjectSelected" label="Proyectos"
					v-model.lazy="selectedProject" name="selectedProject" placeholder="Seleccione una opción">
					<vs-select-item :key="index" :value="item.project_id" :text="item.alias"
						v-for="(item, index) in projectsFilter" class="w-full" />
				</vs-select>
			</div>

			<div class="vx-col w-full sm:w-2/4 lg:w-1/5 mb-4">
				<label for class="vs-input--label">Fecha de inicio</label>
				<datepicker placeholder="Fecha inicio" :language="es" v-model="startDate" format="dd/MM/yyyy"
					:disabledDates="disabledDates" />
			</div>
			<div class="vx-col w-full sm:w-2/4 lg:w-1/5 mb-4">
				<label for class="vs-input--label">Fecha de término:</label>
				<datepicker placeholder="Fecha final" :language="es" v-model="endDate" format="dd/MM/yyyy"
					:disabledDates="disabledDates" />
			</div>
			<div class="vx-col w-full sm:w-2/4 lg:w-1/5 mb-4">
				<div class="flex flex-wrap">
					<vs-button @click="datesChanged" color="dark" class="mt-6 mr-1">Consultar</vs-button>
				</div>
			</div>
		</div>
       
		  <vs-table ref="table" 
		  	:data="chargesToShow"
			stripe
			pagination
			:max-items="itemsPerPage"
			noDataText="No hay datos disponibles">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<!-- ITEMS PER PAGE -->
				<!-- <vs-dropdown v-if="projectsFilter.length == 2" vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
                <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ chargesFiltered.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : chargesFiltered.length }} de {{ queriedItems }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                <vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="itemsPerPage=it" :key="it">
                    <span>{{it}}</span>
                </vs-dropdown-item>            
                </vs-dropdown-menu>
            </vs-dropdown> -->


			</div>

			<template slot="thead">
				<vs-th v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null">{{ col.title
					}}</vs-th>
				<!-- <vs-th v-if="user.user_id == 11838 || user.user_id == 1864">
					<vs-button color="danger" type="line" line-origin="left" @click="dispersePayments()" v-if="!loading" :disabled="disperse.length <= 0">Dispersar ({{ disperse.length }})</vs-button>
				</vs-th> -->
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
					<vs-td>{{ tr.number }}</vs-td>
					<vs-td>{{ regularDateFormat(tr.created_at) }}</vs-td>
					<vs-td>{{ tr.trx_type }}</vs-td>
					<vs-td>{{ tr.concept }}</vs-td>
					<vs-td>{{ costFormat(tr.amount, 2) }}</vs-td>
					<vs-td>
						<div class="flex flex-wrap">
							<vs-icon v-if="costFormat(tr.amount, 2) === costFormat(tr.dispersed, 2)" icon="check_circle"
							size="small" color="green" class="mr-5" />
							<vs-icon v-else-if="tr.dispersed != 0" icon="error" size="small" color="warning" class="mr-5" />
							<vs-icon v-else icon="schedule" size="small" color="silver" class="mr-5" />
							{{ costFormat(tr.dispersed, 2) }}
						</div>
					</vs-td>
					<!-- <vs-td v-if="user.user_id == 11838 || user.user_id == 1864">
						<vs-icon v-if="costFormat(tr.amount, 2) === costFormat(tr.dispersed, 2)" icon="check_circle"
							size="small" color="green" />
						<input type="checkbox" :value="tr.id" v-model="disperse" :disabled="loading"
							v-else-if="tr.dispersed == 0">
					</vs-td> -->
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
import dateHelper from "@mixins/dateHelper";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

const columnDefinitions = [
	{ title: "MES", key: "number", sortable: true },
	{ title: "FECHA", key: "created_at", sortable: true },
	{ title: "TIPO", key: "trx_type", sortable: true },
	{ title: "CONCEPTO", key: "concept", sortable: true },
	{ title: "MONTO", key: "amount", sortable: true },
	{ title: "MONTO DISPERSADO", key: "dispersed", sortable: false },
];

const itemsPerPageDefinitions = [25, 50];

export default {
	name: "Transactions",
	mixins: [formatHelper, dateHelper],
	components: {
		Datepicker,
	},
	props: ['project_id'],
	data() {
		return {
			es: es,
			chargesToShow: [],
			allCharges: [],
			projectsFilter: [],
			selectedProject: 0,
			loading: false,
			isMounted: false,
			columns: columnDefinitions,
			itemsPerPageDefinitions: itemsPerPageDefinitions,
			itemsPerPage: itemsPerPageDefinitions[0],
			disperse: [],
			dataTable: '',
			selectedPeriod: 0,
			periodsFilter: [
				{ text: "Últimos 90 días", value: 0 },
				{ text: "Periodo actual", value: 1 },
				{ text: "Periodo anterior", value: 2 },
				{ text: "Periodo previo al anterior", value: 3 },
			],
			disabledDates: {
				from: new Date(),
			},
			today: new Date(),
			startDate: new Date(
				new Date().getFullYear(),
				new Date().getMonth(),
				new Date().getDate() - 90
			),
			endDate: new Date(
				new Date().getFullYear(),
				new Date().getMonth(),
				new Date().getDate()
			),
		}
	},
	async mounted() {
		await this.getInformation(this.startDate, this.endDate);
		this.isMounted = true;
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.chargesFiltered.length
		},
		chargesFiltered() {
			return this.chargesToShow;
		}
	},
	methods: {
		async getInformation(start, end) {
			if (start == null && end == null) {
				start = this.startDate;
				end = this.endDate;
			}
			this.showLoading(true);
			this.loading = true;

			const data = {
				start: start,
				end: end,
			};

			await axios.post('/api/cobranza/pagos/' + this.project_id, data).then(response => {
				this.allCharges = response.data.trxs;
				this.chargesToShow = this.allCharges;
				this.projectsFilter = response.data.projects;
				this.projectsFilter.unshift({ project_id: 0, alias: 'Todos' });
				this.selectedProject = 0;
				this.loading = false;
			}).catch(error => {
				this.loading = false
				console.log(error);
			});
			this.showLoading(false);
		},
		async dispersePayments() {
			var fa = prompt('Dispersión de los pagos seleccionados. \nConfirma con tu segundo factor de autenticación:', '');
			if (fa != null && fa != '' && this.disperse.length > 0) {
				this.showLoading(true);
				this.loading = true;
				await axios.post('/api/cobranza/dispersar', {
					project_id: this.project_id,
					payments: this.disperse,
					code: fa
				}).then(response => {
					this.disperse = []
					this.successNotif("Aviso", 'Operación exitosa, dispersión en proceso.');
					this.loading = false;
					this.getInformation(this.startDate, this.endDate)
				}).catch(error => {
					this.loading = false
					if (error.response.data.message != undefined) {
						this.errorNotif("Aviso", error.response.data.message, 4000);
					} else {
						this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
					}
					this.getInformation(this.startDate, this.endDate);
				});
				this.showLoading(false);
			}
		},
		setProjectSelected() {
			if (this.selectedProject === 0) {
				this.chargesToShow = this.allCharges;
			} else {
				this.chargesToShow = this.allCharges.filter(p => p.project_id === this.selectedProject);
			}
		},
		async setPeriodSelected() {
			switch (this.selectedPeriod) {
				case 0:
					this.startDate = new Date(
						this.today.getFullYear(),
						this.today.getMonth(),
						this.today.getDate() - 90
					);
					this.endDate = this.today;
					break;
				case 1:
					this.startDate = new Date(
						this.today.getFullYear(),
						this.today.getMonth(),
						1
					);
					this.endDate = new Date(
						this.today.getFullYear(),
						this.today.getMonth() + 1,
						0
					);
					break;
				case 2:
					this.startDate = new Date(
						this.today.getFullYear(),
						this.today.getMonth() - 1,
						1
					);
					this.endDate = new Date(
						this.startDate.getFullYear(),
						this.startDate.getMonth() + 1,
						0
					);
					break;
				case 3:
					this.startDate = new Date(
						this.today.getFullYear(),
						this.today.getMonth() - 2,
						1
					);
					this.endDate = new Date(
						this.startDate.getFullYear(),
						this.startDate.getMonth() + 1,
						0
					);
					break;
				default:
					break;
			}
			await this.getInformation(this.startDate, this.endDate);
		},
		async datesChanged() {
			if (this.startDate > this.endDate) {
				this.errorNotifDialog(
					"Aviso",
					"La fecha de inicio no puede ser mayor a la de fin"
				);
			} else {
				this.selectedPeriod = null;
				await this.getInformation(this.startDate, this.endDate);
			}
		},
	},
}
</script>

<style scoped lang="scss">
::v-deep .vdp-datepicker__calendar {
	position: fixed;
}
</style>